import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
import "./custom.scss";

Vue.use(BootstrapVue);
